import Api from "../Api";

import { GetCustomerPortalLinkResponse, GetUserInfoResponse } from "./types";

class ApiUser extends Api {
  static getUserInfo(userId: string) {
    return ApiUser.instance.axiosInst.get<GetUserInfoResponse>(
      `/users/${userId}/info`
    );
  }

  static getCustomerPortalLink(userId: string) {
    return ApiUser.instance.axiosInst.get<GetCustomerPortalLinkResponse>(
      "/portal",
      {
        params: { userId },
      }
    );
  }
}

export default ApiUser;
